import React, { useState } from 'react';
import { FaFutbol, FaCheckCircle } from 'react-icons/fa';
import SectionCard from '../SectionCard';
import { parseScore } from '../../utils/tournament';
import './MatchResultForm.css';

const teamInitial = (name) => (name ? name.trim().charAt(0).toUpperCase() : '?');

const MatchResultForm = ({
  matches,
  onAddResult,
  title,
  icon,
  description,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  submitLabel,
  submitButtonClassName,
}) => {
  const [results, setResults] = useState({});

  const handleChange = (matchIndex, team, value) => {
    setResults({
      ...results,
      [matchIndex]: {
        ...results[matchIndex],
        [team]: value,
      },
    });
  };

  const handleSubmit = (matchIndex) => {
    const currentResult = results[matchIndex];
    if (currentResult?.team1 === undefined || currentResult?.team2 === undefined) {
      return;
    }

    if (currentResult.team1 === currentResult.team2) {
      return;
    }

    onAddResult(matchIndex, currentResult);
  };

  if (!matches.length) {
    return (
      <SectionCard title={title} icon={icon} description={description}>
        <div className="empty-state">
          <h3>{emptyIcon} {emptyTitle}</h3>
          <p>{emptyDescription}</p>
        </div>
      </SectionCard>
    );
  }

  const completedCount = matches.filter((match) => match.result).length;

  return (
    <SectionCard
      title={title}
      icon={icon}
      description={description}
      actions={(
        <span className="match-progress">
          <FaCheckCircle /> {completedCount}/{matches.length} definidos
        </span>
      )}
    >
      {matches.map((match, index) => {
        const team1Name = match.team1?.name || 'Equipo 1';
        const team2Name = match.team2?.name || 'Equipo 2';
        const isDone = Boolean(match.result);
        const team1Wins = isDone && match.result.team1 > match.result.team2;
        const team2Wins = isDone && match.result.team2 > match.result.team1;

        return (
          <div
            key={`${team1Name}-${team2Name}-${index}`}
            className={`match-card ${isDone ? 'match-card--done' : ''}`.trim()}
            style={{ animationDelay: `${index * 0.06}s` }}
          >
            <div className="match-card__matchup">
              <div className={`match-card__team ${team1Wins ? 'match-card__team--winner' : ''}`.trim()}>
                <span className="match-card__badge">{teamInitial(team1Name)}</span>
                <span className="match-card__name">{team1Name}</span>
              </div>

              {isDone ? (
                <div className="match-card__score">
                  <span>{match.result.team1}</span>
                  <span className="match-card__score-sep">:</span>
                  <span>{match.result.team2}</span>
                </div>
              ) : (
                <span className="match-card__vs">VS</span>
              )}

              <div className={`match-card__team match-card__team--right ${team2Wins ? 'match-card__team--winner' : ''}`.trim()}>
                <span className="match-card__name">{team2Name}</span>
                <span className="match-card__badge">{teamInitial(team2Name)}</span>
              </div>
            </div>

            {isDone ? (
              <p className="match-card__status">
                <FaCheckCircle /> Resultado definido
              </p>
            ) : (
              <div className="match-card__form">
                <label htmlFor={`match-${index}-score1`} className="sr-only">Goles de {team1Name}</label>
                <input
                  id={`match-${index}-score1`}
                  type="number"
                  placeholder={`Goles ${team1Name}`}
                  min="0"
                  onChange={(e) => handleChange(index, 'team1', parseScore(e.target.value))}
                />
                <label htmlFor={`match-${index}-score2`} className="sr-only">Goles de {team2Name}</label>
                <input
                  id={`match-${index}-score2`}
                  type="number"
                  placeholder={`Goles ${team2Name}`}
                  min="0"
                  onChange={(e) => handleChange(index, 'team2', parseScore(e.target.value))}
                />
                <button type="button" className={submitButtonClassName} onClick={() => handleSubmit(index)}>
                  <FaFutbol /> {submitLabel}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </SectionCard>
  );
};

export default MatchResultForm;
